import { IReleaseNote } from "../types"

export const RELEASE_MIGRATION: IReleaseNote = {
    status: "PAST",
    title: "API v2 - Migration Guide",
    date: "30th September 2025",
    releaseType: "Guide",
    notesBodyAllUsers: [
        {
            heading: "Migrate from API v1 to v2",
            content:
                "We're excited to announce that on the 30th September 2025, ENA Connect Direct rolled out API v2 changes in select areas. This new version introduced several important changes to the existing API. This page provides a guide outlining the key updates to help you migrate your code from API v1 to API v2 smoothly.",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using our APIs",
            subtitle: "The relevant changes are as follows:",
            bullets: [
                "Provide Export MPAN: If applicable, DNOs can provide an export MPAN for applications that have reached the 'Commissioning Accepted' status. Once provided, the application will progress to the 'EX MPAN Provided' state, which is now the terminal status ",
                "AI information: New added information within the application summary page - DNO Assumed Cut-Out Rating, Cut-Out Type, and Cut-Out Type Identified",
            ],
        },
        {
            subtitle: "What you need to do to get ready:",
            content:
                "To support recent changes to the application status flow, the following endpoints are supported by v2. Please ensure your system reflects these changes",
            bullets: [
                "Provide Export MPAN: New endpoint to provide export MPANs POST /dno-commissioning/v2/export-mpan",
                "Application listing: POST /dno-application/v1/applications is now POST /dno-application/v2/applications. This endpoint may now also return the new status: EX MPAN PROVIDED",
            ],
        },
        {
            subtitle: "Roll Out Plan:",
            content:
                "API users have access to the TST endpoints to begin testing and adapt their integrations to the new specification.",
        },
        {
            heading: "For DNOs using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using our APIs",
            subtitle: "The relevant changes are as follows:",
            bullets: [
                "Commission applications can be assigned an export MPAN by the DNO, resulting in a new terminal status 'Ex Mpan Provided'. As a result, the endpoint for the 'My Applications' page will be updated to use the v2 API.",
            ],
        },
        {
            subtitle: "What you need to do to get ready:",
            content:
                "To support recent changes to the application status flow, the following endpoints have been updated from v1 to v2. Please ensure your system reflects these changes",
            bullets: [
                "Application listing: POST /connection-application/v1/applications is now, POST /connection application/v2/applications. This endpoint may now also return the new status: EX MPAN Provided",
            ],
        },
        {
            subtitle: "Roll Out Plan:",
            content:
                "API users have access to the TST endpoints to begin testing and adapt their integrations to the new specification.",
        },
        {
            heading: "For installers using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "No changes to your functionality",
        },
    ],
}
export const RELEASE_MIGRATION_2: IReleaseNote = {
    status: "PAST",
    title: "API v3 - Migration Guide",
    date: "24th August 2026",
    releaseType: "Guide",
    notesBodyAllUsers: [
        {
            heading: "Migrate from API v2 to v3",
            content:
                "On 24th August 2026, ENA Connect Direct rolled out API v3 changes across selected areas. This version introduces several important updates to the existing API. This guide outlines the key changes to help you migrate your integration from API v2 to API v3 smoothly.",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using our APIs",
            subtitle: "The relevant changes are as follows:",
            bullets: [
                "Provide a DNO Works Required response: DNOs can now provide a fourth response option to an application. Once submitted, the application will move to the `DNO Works Required` state, where it must be reassessed before progressing to a terminal state.",
                "New technologies: Applications can now be submitted for `Air Conditioning Units` and `Electric Boilers`.",
            ],
        },
        {
            subtitle: "What you need to do to get ready:",
            content:
                "To support these application status flow changes, please ensure your system uses the v3 endpoints below.",
            bullets: [
                "Application listing: Use POST /dno-application/v3/applications. This endpoint may now return the new status `DNO Works Required` and the new technologies `Air Conditioning Units` and `Electric Boilers`.",
            ],
        },
        {
            subtitle: "Roll Out Plan:",
            content:
                "API users have access to the TST endpoints to begin testing and adapt their integrations to the new specification.",
        },
        {
            heading: "For DNOs using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using our APIs",
            subtitle: "The relevant changes are as follows:",
            bullets: [
                "Applications can now be assigned the `DNO Works Required` status by the DNO. This is an intermediate status used to capture additional information, and the application will need to be reassessed before moving forward. As a result, the endpoint used by the 'My Applications' page will be updated to v3.",
                "New technologies: Applications can now include `Air Conditioning Units` and `Electric Boilers`. This applies only if you are submitting applications for these technologies, and will be reflected on the application summary page.",
                "Address Search: The address search functionality has changed it's response from a 400 too short error to a 529.",
            ],
        },
        {
            subtitle: "What you need to do to get ready:",
            content:
                "To support these application status flow changes, the endpoint below has been updated from v2 to v3. Please ensure your system reflects this change.",
            bullets: [
                "Application listing: Use POST /connection-application/v3/applications. This endpoint may now return the new status `DNO Works Required` and the new technologies `Air Conditioning Units` and `Electric Boilers`.",
                "Address Search: Use GET /location/v1/autocomplete. This endpoint may now return a 529 error for too short or long search terms.",
            ],
        },
        {
            subtitle: "Roll Out Plan:",
            content:
                "API users have access to the TST endpoints to begin testing and adapt their integrations to the new specification.",
        },
        {
            heading: "For installers using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "No changes to your functionality",
        },
    ],
}
